const customSelectElements = $('.select-custom');

if (customSelectElements.length > 0) {
  for (let i = 0; i < customSelectElements.length; i++) {
    // Get custom select element
    const customSelectElement = customSelectElements[i];

    $(customSelectElement).select2({
      language: {
        noResults: function () {
          return 'Không tìm thấy kết quả';
        },
      },
      allowClear: true,
      closeOnSelect: true,
      dropdownParent: customSelectElement.closest('.select-parent'),
    });
  }
}
